/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { computed as a, toValue as f } from "vue";
import { useRoute as m } from "vue-router";
function o(t, e) {
  if (!(!t || !e))
    return e === !0 ? t : e.reduce((r, u) => (t[u] !== void 0 && (r[u] = t[u]), r), {});
}
const l = (t, e) => {
  const r = t.attrs, u = m(), n = a(() => !r.to || typeof r.to == "string" ? r.to : {
    ...r.to,
    params: {
      ...o(u.params, f(e == null ? void 0 : e.preserveRouteParams) || !1),
      ..."params" in r.to ? r.to.params : void 0
    },
    query: {
      ...o(u.query, f(e == null ? void 0 : e.preserveRouteQuery) || !1),
      ...r.to.query
    }
  });
  return {
    component: a(() => n.value ? "router-link" : r.href ? "a" : r.tag && typeof r.tag == "string" ? r.tag : "button"),
    bindings: a(() => ({
      ...r,
      to: n.value,
      ...n.value || r.href || r.tag && r.tag !== "button" ? void 0 : { type: r.type || "button" }
    }))
  };
};
export {
  l as useCtaComponent
};
